import { memo } from 'react';
import LoadingButton from "@mui/lab/LoadingButton";
import AltRouteIcon from "@mui/icons-material/AltRoute";
import When from 'ui/support/When';
import { useFakeRedirect } from "./support";
import useTransactionAction from './useTransactionAction';
import { fakeRedirect } from 'features/transactions/api';
import useActions from 'features/general/useActions';
import { NotificationSeverity } from 'features/general/types';
import { delay } from 'util/support';

const FakeRedirect = () => {
    const {
        isLoading,
        transaction,
        request
    } = useTransactionAction();

    const { showNotication } = useActions();

    const { checkIfFakeRedirect } = useFakeRedirect(transaction);

    const onClick = () => request(() => fakeRedirect(transaction), {
        onSuccess: async payload => {
            showNotication({
                message: 'Redirecting in 3 seconds',
                severity: NotificationSeverity.Warning,
            });

            await delay(3000);

            const objectUrl = URL.createObjectURL(
                new Blob([payload.data], { type: "text/html" })
            );

            window.open(objectUrl, "_blank");
        }
    });

    return (
        <When
            if={checkIfFakeRedirect}
            then={(
                <LoadingButton
                    data-test-id="transactions.transactionActions.fakeRedirect"
                    startIcon={(
                        <AltRouteIcon />
                    )}
                    onClick={onClick}
                    loading={isLoading}
                    variant='outlined'
                    size='small'
                >
                    PoD
                </LoadingButton>
            )}
        />
    );
};

export default memo(FakeRedirect);
